import { TestReports } from "./icons"
import {
    RecentActorsOutlined,
    HolidayVillageOutlined,
    TouchAppOutlined,
    OndemandVideoOutlined
} from "@mui/icons-material"
import { ICONS } from "../Images/index"

const imgStyle = {
    "width": "auto",
    "height": "auto",
    "maxWidth": "200px",
    "maxHeight": "200px",
    "objectFit": "contain",
    "borderRadius": "8px",
    "boxShadow": "0 4px 12px rgba(0,0,0,0.15)"
}

export const service_list = [
    {
        "title": "Admission Management",
        "icon": <img src={ICONS.admission} alt="Admission" style={imgStyle} />,
        "to": "/stock",
        "list": [
            "To take new admission for student click on Take Admission button",
            "To create new class click on Create Class button"
        ],
        actions: [
            "Take Admission",
            "Create Class"
        ]
    },
    {
        "title": "Examination Admit Card",
        "icon": <img src={ICONS.admit} alt="Admission" style={imgStyle} />,
        "to": "/admit",
        "list": [
            "Select the examination for which admit cards need to be generated.",
            "Choose a class or specific students to generate admit cards.",
            "Verify student details before generating the admit cards.",
            "Update the status for make sure student can view the admit card"
        ],
        actions: [
            {
                label: "Examination Admit Card",
                to: "/admit/classes"
            },
        ]
    },
    {
        "title": "Exam Timetable Planning",
        "icon": <img src={ICONS.examTimeTable} alt="Admission" style={imgStyle} />,
        "to": "/exam",
        "list": [
            "To Create Examination timetable click on Create Exam Button",
            "To Edit the Examination timetable click on Manage Exam Button"
        ],
        actions: [
            {
                label: "Create Exam",
                to: "/exam/create"
            },
            {
                label: "Manage Exam",
                to: "/exam/manage"
            }
        ]
    },
    {
        "title": "Monthly Fee",
        "icon": <img src={ICONS.monthlyFee} alt="Admission" style={imgStyle} />,
        "to": "/fee",
        "list": [
            "To update monthly fee details, click on Update Fee.",
            "You can add or modify fee amounts for different classes and sections.",
            "Review fee structures before publishing changes.",
            "Ensure all fee records are updated before generating fee reports."
        ],
        actions: [
            {
                label: "Update Fee",
                to: "/fee"
            },
        ]
    },
    {
        "title": "Class Subject's",
        "icon": <img src={ICONS.classSubject} alt="Admission" style={imgStyle} />,
        "to": "/subjects",
        "list": [
            "Create Class subjects",
            "Create Class Minor subjects"
        ],
        actions: [
            {
                label: "Create Subject",
                to: "/subjects"
            },
        ]
    },
    {
        "title": "Result Management",
        "icon": <img src={ICONS.examinationResult} alt="Admission" style={imgStyle} />,
        "to": "/result",
        "list": [
            "While import and publish the result make sure the student marks and status update on excel table.",
            "Base on status value (Yes/No) student will be able to see result.",
            "Before publish the result,the examination mark configuration must be configure. "
        ],
        actions: [
            {
                label: "Publish Examination Result",
                to: "/result"
            },
        ]
    },
    {
        "title": "Certificate Management",
        "icon": <img src={ICONS.document} alt="Admission" style={imgStyle} />,
        "to": "/stock",
        "list": [
        ],
        "actions": [
            {
                label: "Provisional",
                to: "/certificates/ProvisionalCertificate"
            },
            {
                label: "Character",
                to: "/certificates/characterCertificate"
            },
            {
                label: "Sports",
                to: "/certificates/sportsCertificate"
            },
            {
                label: "Promotion",
                to: "/certificates/promotionCertificate"
            },
            {
                label: "Transfer",
                to: "/certificates/TransferCertificate"
            },
            {
                label: "School Leaving",
                to: "/certificates/leavingCertificates"
            },
            {
                label: "Bonafide",
                to: "/certificates/BonafideCertificate"
            }
        ]
    },
    {
        "title": "Lecture Courses",
        "icon": <OndemandVideoOutlined style={{
            color: "black",
            fontSize: "80px"
        }} />,
        "to": "/lectures",
        "list": [
            "Create courses with a price, then add lecture videos to each one.",
            "Students browse and buy them in the lecture portal at /learn."
        ],
        actions: [
            {
                label: "Manage Courses",
                to: "/lectures"
            }
        ]
    }
]
export const service__list_student = [
    {
        "title": "Test Report's",
        "icon": <TestReports />,
        "to": "/stock",
        "list": [

        ]
    },
    {
        "title": "Admit Card",
        "icon": <RecentActorsOutlined style={{
            color: "black",
            fontSize: "80px"
        }} />,
        "to": "/stock",
        "list": [
        ]
    },
    {
        "title": "Holiday Calendar",
        "icon": <HolidayVillageOutlined style={{
            color: "black",
            fontSize: "80px"
        }} />,
        "to": "/stock",
        "list": [
        ]
    },
    {
        "title": "Apply Leave",
        "icon": <TouchAppOutlined style={{
            color: "black",
            fontSize: "80px"
        }} />,
        "to": "/stock",
        "list": [
        ]
    },
]